import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { mockInterceptor } from './mock.Interceptor';

@NgModule({
  declarations: [],
  imports: []
})
export class MockModule {
  static forRoot(mockConfig: Provider): ModuleWithProviders<MockModule> {
    return {
      ngModule: MockModule,
      providers: [mockConfig, provideHttpClient(withInterceptors([mockInterceptor]))]
    };
  }
}
